import { HtmlTooltip } from './HTMLTooltip';

export default HtmlTooltip;